import { render } from "./AtencionesPorEdad.vue?vue&type=template&id=388b90c6&scoped=true"
import script from "./AtencionesPorEdad.vue?vue&type=script&lang=js"
export * from "./AtencionesPorEdad.vue?vue&type=script&lang=js"

import "./AtencionesPorEdad.vue?vue&type=style&index=0&id=388b90c6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388b90c6"]])

export default __exports__